export const ADD_ARTICLE = 'add_article'
export const DELETE_ARTICLE = 'delete_article'
export const INIT_ARTICLE = 'init_article'

export const INIT_INFO = 'init_info'
export const EDIT_INFO = 'edit_info'
export const DELETE_INFO = 'delete_info'
